import Label from "@components/form/Label";
import Legend from "@components/form/Legend";
import TextArea from "@components/form/TextArea";
import TextInput from "@components/form/TextInput";
import { useMessageContext } from "@context/MessageContext";
import { FunctionComponent, useEffect, useId } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import StepActions from "@components/zenith/ui/StepActions";

type CreateNotificationStep1Props = {
  originalNotification?: any;
  onSubmit: () => void;
};

const CreateNotificationStep1: FunctionComponent<
  CreateNotificationStep1Props
> = ({ originalNotification, onSubmit }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { message, setMessage } = useMessageContext();
  const id = useId();

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    onSubmit?.();
  };

  useEffect(() => {
    if (originalNotification) {
      setMessage({
        ...message,
        subject:
          message?.subject ||
          t("notification.reply_prefix") +
            originalNotification.relatedMessage?.subject,
        body:
          message?.body ||
          "\n\n\n\n-------------------------------------\n" +
            originalNotification.relatedMessage?.body
              ?.split("\n")
              .map((line: string) => "> " + line)
              .join("\n"),
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [originalNotification]);

  return (
    <form className="flex flex-col grow" onSubmit={handleSubmit}>
      <div className="flex flex-col grow gap-10">
        <fieldset className="w-full flex flex-col gap-2">
          <Legend>{t("notification.message")}</Legend>
          <div>
            <Label htmlFor={`${id}-recipients`}>
              {t("notification.recipients")}
            </Label>
            <TextInput
              id={`${id}-recipients`}
              type="text"
              value={t("common.administrators") as string}
              readOnly
              disabled
            />
          </div>
          <div>
            <Label htmlFor={`${id}-subject`}>
              {t("notification.enter_subject")}
            </Label>
            <TextInput
              id={`${id}-subject`}
              type="text"
              required
              value={message?.subject || ""}
              onChange={e =>
                setMessage({
                  ...message,
                  subject: e.target.value,
                })
              }
            />
          </div>
          <div>
            <Label htmlFor={`${id}-body`}>{t("notification.enter_body")}</Label>
            <TextArea
              id={`${id}-body`}
              className="h-64"
              required
              value={message?.body || ""}
              onChange={e =>
                setMessage({
                  ...message,
                  body: e.target.value,
                })
              }
            />
          </div>
        </fieldset>
      </div>
      <StepActions onCancel={() => navigate("/zenith/notifications")} />
    </form>
  );
};

export default CreateNotificationStep1;
